import { render, staticRenderFns } from "./targetiscontentDIalog.vue?vue&type=template&id=24bc50a5&scoped=true&"
import script from "./targetiscontentDIalog.vue?vue&type=script&lang=js&"
export * from "./targetiscontentDIalog.vue?vue&type=script&lang=js&"
import style0 from "./targetiscontentDIalog.vue?vue&type=style&index=0&id=24bc50a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc50a5",
  null
  
)

export default component.exports